export default __webpack_public_path__ + "static/media/menu2.2b87ca60.png";